import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import useDataStore from '../Data/dataStore';
import usePageStore from './pageStore';
import { FOOTER_ID, footerKey, isMobile, sectionChangeTimeout, } from '../globalUtils';
import Stepper from './Stepper';
import useMenuStore from '../Menu/menuStore';
const PageFeedback = () => {
    const { open: menuOpen } = useMenuStore();
    const { shownPage, activePage, pageChangeCount, activeSection, blockSnap } = usePageStore();
    const pageContent = useDataStore((state) => state.data[shownPage]?.page_sections);
    const isSnap = useDataStore((state) => state.data[shownPage]?.snap);
    const [isHidden, setIsHidden] = useState(true);
    const [mounted, setMounted] = useState(false);
    const hiddenTimeout = useRef(0);
    useEffect(() => {
        if (!mounted && pageContent) {
            setMounted(true);
        }
    }, [pageContent]);
    useEffect(() => {
        if ((!shownPage || activePage !== shownPage) && !isHidden) {
            setIsHidden(true);
        }
        if (shownPage && activePage === shownPage && isHidden) {
            clearTimeout(hiddenTimeout.current);
            hiddenTimeout.current = window.setTimeout(() => {
                setIsHidden(false);
            }, 600);
        }
    }, [activePage, shownPage, pageChangeCount]);
    const activeSectionRef = useRef(activeSection);
    activeSectionRef.current = activeSection;
    const definedFooter = pageContent?.length &&
        pageContent[pageContent.length - 1].type === footerKey;
    const buttons = pageContent
        ? definedFooter
            ? pageContent
            : [...pageContent, { name: FOOTER_ID }]
        : [];
    const gotoSection = (idx) => {
        //TODO: this is a potentially dangerous operation without clearing the timeouts
        usePageStore.getState().setBlockSnap(blockSnap + 1);
        usePageStore.getState().setActiveSection(idx);
        //usePageStore.getState().setBlockFixed(true);
        setTimeout(() => document
            .querySelectorAll('.page-wrapper section')?.[idx]?.scrollIntoView({ behavior: (isSnap ? 'instant' : 'smooth') }), 10);
        setTimeout(() => {
            if (activeSectionRef.current === idx) {
                usePageStore.getState().setShownSection(idx);
            }
            //  usePageStore.getState().setBlockFixed(false);
        }, sectionChangeTimeout * 1000);
    };
    const hidden = !mounted || isHidden || !isSnap || menuOpen;
    return isMobile ? null : (_jsx("div", { className: "page-feedback", children: _jsx(Stepper, { length: buttons.length, active: activeSection, hidden: hidden, onClick: gotoSection }) }));
};
export default PageFeedback;
